import type { DateValue } from "react-aria-components";

type DateParts = Pick<DateValue, "year" | "month" | "day">;

const capitalize = (text: string) =>
  text.charAt(0).toLocaleUpperCase() + text.slice(1);

// a local-midnight Date keeps Intl from shifting the day across time zones
const toLocalDate = ({ year, month, day }: DateParts) =>
  new Date(year, month - 1, day);

// "Monday, 20.5.2026": the weekday reads faster than a bare number
export const formatPickedDate = (date: DateParts, locale: string) => {
  const weekday = new Intl.DateTimeFormat(locale, { weekday: "long" }).format(
    toLocalDate(date),
  );
  return `${capitalize(weekday)}, ${date.day}.${date.month}.${date.year}`;
};

export const formatCalendarMonth = (date: DateParts, locale: string) =>
  capitalize(
    new Intl.DateTimeFormat(locale, { month: "short", year: "numeric" })
      .format(toLocalDate(date))
      .replace(".", ""),
  );

// two letters per weekday ("Mo", "Tu"), from the locale's short name
export const formatWeekday = (shortName: string) =>
  capitalize(shortName.slice(0, 2));
